<script setup>
import { Link } from '@inertiajs/vue3'
defineProps({
  title:  { type: String,  required: true },
  url:    { type: String,  required: true },
  active: { type: Boolean, default: false },
})
</script>
<template>
  <li :data-active="active ? 'true' : undefined">
    <Link
      :href="url"
      :class="[
        'flex items-center gap-3 px-3 py-2.5 rounded-lg mx-1 transition-all duration-150 group',
        active
          ? 'bg-green-400/30 text-white shadow-sm'
          : 'text-white/80 hover:bg-green-400/25 hover:text-white',
      ]"
    >
      <span
        :class="[
          'w-8 h-8 flex items-center justify-center rounded-lg shrink-0 transition-all',
          active
            ? 'bg-green-400/30 text-white'
            : 'bg-white/10 text-white/80 group-hover:bg-green-400/25 group-hover:text-white',
        ]"
      >
        <slot />
      </span>
      <span class="text-sm font-medium leading-none">{{ title }}</span>
      <span
        v-if="active"
        class="ml-auto w-1.5 h-1.5 rounded-full bg-green-400 shrink-0"
      />
    </Link>
  </li>
</template>